

(function () {
    'use strict';

/**
 * Created by dushyantha on 10/4/16.
 */
angular
    .module('commons')
    .directive('customOnChange', customOnChange);

function customOnChange($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var onChangeFunc = scope.$eval(attrs.customOnChange);
            element.bind('change', onChangeFunc);
        }
    };
}

}());

